import React, { useState, useEffect } from "react";
import {
  Input,
  Select,
  Col,
  Row,
  Form,
  notification,
  Button,
  Switch,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";
const { Option } = Select;
const layout = {
  labelCol: {
    span: 14,
  },
  wrapperCol: {
    span: 10,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 5,
    span: 20,
  },
};
const openNotificationWithIcon = (type) => {
  notification[type]({
    message: "BAŞARILI",
    description: "Ekleme işlemi başarı ile gerçekleşti.",
    duration: 2,
  });
};

const FirmClassAddForm = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });

  const [loading, setLoading] = useState(false);
  const [firmTypeDropdown, setfirmTypeDropdown] = useState([]);

  useEffect(() => {
    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setfirmTypeDropdown(response.data);
    });
  }, [setfirmTypeDropdown]);

  const onFinish = (values) => {
    RequestHandler.post(
      `/FirmClass`,
      {
        name: values.Name,
        firmTypeValue: values.FirmTypeValue,
        erpValue: values.ErpValue,
        serialNumber: values.SerialNumber,
        isErpType: values.isErpType,
        parentFirmClassName:values.ParentFirmClassName
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        openNotificationWithIcon("success");
        setTimeout(
          function () {
            window.location.reload();
          }.bind(this),
          2000
        );
      } else {
        setLoading(false);
      }
    });
  };

  const onFinishFailed = () => setLoading(false);

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={18}>
                <Form.Item
                  label="Bayi Sınıfı Adı"
                  name="Name"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen bayi sınıfı adı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Ana İşlem Sınıfı" name="ParentFirmClassName">
                  <Select allowClear placeholder="Boş">
                    <Select.Option key={"Bayi"} value={"Bayi"}>
                      Bayi
                    </Select.Option>
                    <Select.Option key={"Banka"} value={"Banka"}>
                      Banka
                    </Select.Option>
                    <Select.Option key={"Masraf"} value={"Masraf"}>
                    Masraf
                    </Select.Option>
                    <Select.Option key={"Cek"} value={"Cek"}>
                      Çek
                    </Select.Option>
                    <Select.Option key={"Senet"} value={"Senet"}>
                    Senet
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Bayi Tipi"
                  name="FirmTypeValue"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Bayi Tipi alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Seçiniz"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Seri No"
                  name="SerialNumber"
                  style={{ marginTop: "4%" }}
                >
                  <Input maxLength={20} />
                </Form.Item>
                <Form.Item
                  label="Erp Kod"
                  name="ErpValue"
                  style={{ marginTop: "4%" }}
                >
                  <Input maxLength={100} />
                </Form.Item>

                <Form.Item
                  label="Erp Aktarım'da kullanılsın mı?"
                  name="isErpType"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={9}></Col>
              <Col span={7}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={2}></Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Bayi Sınıfı Adı"
                  name="Name"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen bayi sınıfı adı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Bayi Tipi"
                  name="FirmTypeValue"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Bayi Tipi alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Seçiniz"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Seri No"
                  name="SerialNumber"
                  style={{ marginTop: "4%" }}
                >
                  <Input maxLength={20} />
                </Form.Item>
                <Form.Item
                  label="Erp Kod"
                  name="ErpValue"
                  style={{ marginTop: "4%" }}
                >
                  <Input maxLength={100} />
                </Form.Item>

                <Form.Item
                  label="Erp Aktarım'da kullanılsın mı?"
                  name="isErpType"
                  valuePropName="checked"
                >
                  <Switch />
                </Form.Item>
              </Col>
              <Col span={12}></Col>
              <Col span={6}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Ekle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};
export default FirmClassAddForm;
